import { create } from "zustand";

// Lets other UI (e.g. JourneyHero cards) open the single on-page AiCoachChat
// instead of navigating to a separate page. Expand/collapse state lives here
// rather than as local AiCoachChat state so it can be controlled externally.
interface CoachChatUiState {
  isExpanded: boolean;
  open: () => void;
  close: () => void;
}

export const useCoachChatUiStore = create<CoachChatUiState>((set) => ({
  isExpanded: false,
  open: () => set({ isExpanded: true }),
  close: () => set({ isExpanded: false }),
}));
